import DialogComponent from "components/Dialog";

export default class RefuseTratPlanDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            comment: "",
        };

        this.state = { ...this.defaultState };
    }

    title = "treatmentPlan.refuse";

    show(info, hideCb) {
        this.info = info;
        this.hidCb = hideCb;

        super.show();
    }
    
    onInputChange(value) {
        this.state.comment = value;
    }

    save() {
        const { comment } = this.state;

        if (!comment)
            return;

        if (this.hidCb?.apply)
            this.hidCb(this.info.id, comment, true);

        this.hide();
    }

    renderContent() {
        return (
            <div className="content flex col gap16">
                {this.insertTextarea({
                    label: "main.comment",
                    placeHolder: "main.comment",
                    onChange: this.onInputChange.bind(this)
                })}
            </div>
        );
    }
}
